import React from "react";
import { Link } from "react-router-dom";
import CreatorFaq from "../CreatorFaq/CreatorFaq";
import "./CreatorHelpCenter.css";

/**
 * Public Help Center (/creator-help), linked from the creator login page.
 * The same creator FAQ the sidebar shows, in a logged-out shell; its
 * "Contact support" links go to the login page's Contact Support form.
 */
export default function CreatorHelpCenter() {
  return (
    <div className="creator-help">
      <header className="ch-header">
        <Link to="/creator-login" aria-label="Back to sign in">
          <img
            className="ch-logo"
            src={`${process.env.PUBLIC_URL}/${process.env.REACT_APP_LOGO}`}
            alt={process.env.REACT_APP_TITLE || "Logo"}
          />
        </Link>
        <nav className="ch-nav">
          <Link className="ch-btn ch-btn-ghost" to="/creator-login?contact=1">
            Contact Support
          </Link>
          <Link className="ch-btn ch-btn-primary" to="/creator-login">
            Sign in
          </Link>
        </nav>
      </header>

      <main className="ch-main">
        <span className="ch-kicker">Help Center</span>
        <CreatorFaq isPublic />
      </main>
    </div>
  );
}
